export const adjustDataToFetch = data => {
  return {
    identity_document: {
      identity_document_key: data.identity_document
    },
    sex: {
      sex_key: data.sex
    },
    person_type: {
      person_type_key: data.personTypeKey
    },
    fio: `${data.last_name} ${data.first_name} ${data.middle_name}`,
    first_name: data.first_name,
    second_name: data.last_name,
    middle_name: data.middle_name,
    mobile_number:
      data.phone_code &&
      data.phone_number &&
      data.phone_code + data.phone_number,
    phone_code: data.phone_code,
    phone_number: data.phone_number,
    acbpdp_need: data.acbpdp_need,
    birth_date: data.birth_date && data.birth_date.format("YYYY-MM-DD"),
    citizenship: data.citizenship,
    identity_document_series: data.identity_document_series,
    identity_document_num: data.identity_document_num
  }
}